export enum CacheKeys {
  // Internal Order
  CATEGORY_LIST_WITH_PRODUCTS = "categoryListWithProducts", // List all the categories for create order
  TRANSACTIONS = "transactions", // List all the transactions in an order
  PRODUCT_AVAILABILITY_PER_MONTH = "productAvailabilityPerMonth", // List all the product available date in a month for create order
  PRODUCT_AVAILABILITY_PER_DATE = "productAvailabilityPerDate", // List all the available slots in the selected date for create order
  PRODUCT_PRICE = "productPrice", // List all the units of product based on selected timeslot for create order
  CUSTOMERS = "customers", // List all the customers
  CART = "cartDetails", // Details of a cart
  CART_PARTICIPANTS = "cartParticipants", // List all the participants details in a cart
  CART_BOOKING_FIELDS = "cartBookingFields", // List all the per booking fields of the cart
  NOTES = "notes", // General key for all types of notes (cart, cart item, order, order item & customer)
  INTEGRATIONS = "integrations", // List all the business/payment integrations
  ORDER_FIELDS = "orderFields", // List all the order fields of the domain
  OFFERS = "offers", // List all the available offers
  CUSTOMER_MEMBERSHIPS = "customerMemberships", // List all the memberships of a customer
  AFFILIATES = "customers", // List all the customers
  PRODUCT_FIELDS = "productFields", // List all the fields of a product
  PRODUCT_ADDONS = "productAddons", // List all the addons of a product
  GIFTCARD_VALIDITY = "giftcardValidity", // Expiry and other giftcard info
  LIVE_CAPACITY = "liveCapacity", // List all the live capacity of a product
  BOOKED_COUNT = "bookedCount", // List all the booked count of a product
  PRODUCT_DETAILS = "productDetails", // List all the details of a product
  ACTIVE_PRODUCTS_FOR_MEMBERSHIP = "activeProductsForMembership", // List all the active products for a membership
  ACTIVE_PRODUCTS_FOR_CUSTOMER_LOGGED_IN = "activeProductsForCustomerLoggedIn", // List all the active products for a customer logged in
  ACTIVE_PRODUCTS = "activeProducts", // List all the active products
  ALL_PRODUCT_AVAILABILITY = "allProductAvailability", // List all the product availibility
  PRICING_SEASON = "pricingSeason", // List pricing season details
  ALL_CATEGORIES_WITH_PRODUCTS = "allCategoriesWithProducts", // List all the categories with products
}
